/**
 * calendarWeekdays — 현재 locale 의 요일 라벨 배열 (일요일 시작, 0~6).
 *
 * 캘린더 그리드(월/주 뷰) 와 미니 달력 헤더에서 공통 사용.
 * Intl.DateTimeFormat 으로 locale 별 요일명 생성 — 한국어 "일", 일본어 "日", 영어 "Sun".
 */
import { i18n } from '@lingui/core';

const FALLBACK = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function weekdayLabels(style: 'short' | 'narrow' = 'short'): string[] {
  const loc = i18n.locale || 'en';
  try {
    const fmt = new Intl.DateTimeFormat(loc, { weekday: style });
    // 2024-01-07 은 일요일 → +i 로 일~토
    return Array.from({ length: 7 }, (_, i) => fmt.format(new Date(2024, 0, 7 + i)));
  } catch {
    return FALLBACK;
  }
}
